import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import {Link} from 'react-router-dom'
import {injectIntl} from 'react-intl'
import Header from 'containers/Header/Desktop'
import Sidebar from 'containers/Sidebar'
import Container from 'components/Container'
import {isMobile} from 'utils/utils'
import MainSettings from './MainSettings'
import Verification from './Verification'
import Users from './Users'
import route from 'utils/enums/route'

const Name = styled.div`
    display: flex;
    align-items: center;
    margin-right: auto;
    font-weight: 700;
    font-size: 20px;
    overflow: hidden;

    > div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`

const Menu = styled.div`
    background-color: rgba(0, 0, 0, .4);
    padding: 10px 0;
    top: 117px;
    position: absolute;
    width: 100%;
`

const Item = styled(Link)`
    padding: 10px 20px;
    color: ${props => props.selected ? '#ffc300' : 'rgba(255, 255, 255, .7)'};
    width: 100%;
    font-weight: 700;
    font-size: 13px;
    cursor: pointer;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    :hover {
        background-color: rgba(0, 0, 0, .4);

        > span {
            filter:  grayscale(0);
        }
    }

    > span {
        filter: ${props => props.selected ? 'grayscale(0)' : 'grayscale(100%)'};
        min-width: 40px;
    }

    > div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`

const items = {
    main: {
        icon: 'maintenance',
        name: 'main'

    },
    users: {
        icon: 'clients',
        name: 'users'
    },
    verification: {
        icon: 'contact2',
        name: 'verification'
    }
}

const Settings = ({intl}) => {
    const navigate = useNavigate()
    const permissions = useSelector(state => state.login.permissions)
    const logo = useSelector(state => state.applications.logo)
    const params = useParams()
    const type = params.section
    const mobile = isMobile()

    useEffect(() => {
        if (mobile || !permissions.Admin) {
            navigate('/', {replace: true})
        }
    }, [permissions.Admin, mobile])

    return (
        <React.Fragment>
            <Header padding={global.SIDE_BAR_NORMAL_WIDTH}>
                <Name>
                    {intl.formatMessage({id: "app.application_administration"})}
                </Name>
            </Header>
            <Sidebar logo={logo}>
                <Menu>
                    {Object.values(items).map(obj =>
                        <Item
                            key={obj.name}
                            to={`/${route.Settings}/${obj.name}`}
                            selected={obj.name === type}
                        >
                            <span className={"entity-icon-medium entity-icon-" + obj.icon} />
                            <div>{intl.formatMessage({id: `settings.${obj.name}`})}</div>
                        </Item>
                    )}
                </Menu>
            </Sidebar>
            <Container marginTop={117} style={{padding: '20px 20px 20px 276px', marginLeft: 0}}>
                {type === items.main.name &&
                    <MainSettings />
                }
                {type === items.verification.name &&
                    <Verification />
                }
                {type === items.users.name &&
                    <Users />
                }
            </Container>
        </React.Fragment>
    )
}

export default injectIntl(Settings)
